import React, { FC } from "react"

import { Box, Card, Group, Image, Stack, Text, useMantineTheme } from "@mantine/core"
import { IconMapPin } from "@tabler/icons-react"

import { useLanguage } from "../../../../contexts/language-context"
import { DeviceDocument } from "../../../../contexts/devices-context"

type DeviceSummaryLocationCardProps = { coordinates: NonNullable<DeviceDocument["coordinates"]> }

const DeviceSummaryLocationCard: FC<DeviceSummaryLocationCardProps> = ({ coordinates }) => {
    const { L, code } = useLanguage()
    const theme = useMantineTheme()
    const params = new URLSearchParams([
        ["size", "600x180"],
        ["markers", `${coordinates.latitude},${coordinates.longitude}`],
        ["zoom", "13"],
        ["language", code],
        ["key", import.meta.env.VITE_GOOGLE_MAPS_API_KEY],
        ["style", "feature:poi|visibility:off"],
        ["style", "feature:poi.park|visibility:on"],
        ...(theme.colorScheme === "dark" ? [
            ["style", "element:geometry.fill|color:0x242f3e"],
            ["style", "element:labels.text.stroke|color:0x242f3e"],
            ["style", "element:labels.text.fill|color:0x746855"],
            ["style", "feature:administrative.locality|element:labels.text.fill|color:0xd59563"],
            ["style", "feature:poi|element:labels.text.fill|color:0xd59563"],
            ["style", "feature:poi.park|element:geometry|color:0x3d4d41"],
            ["style", "feature:poi.park|element:labels.text.fill|color:0x6b9a76"],
            ["style", "feature:road|element:geometry|color:0x38414e"],
            ["style", "feature:road|element:geometry.stroke|color:0x212a37"],
            ["style", "feature:road|element:labels.text.fill|color:0x9ca5b3"],
            ["style", "feature:road.highway|element:geometry|color:0x746855"],
            ["style", "feature:road.highway|element:geometry.stroke|color:0x1f2835"],
            ["style", "feature:road.highway|element:labels.text.fill|color:0xf3d19c"],
            ["style", "feature:transit|element:geometry|color:0x2f3948"],
            ["style", "feature:transit.station|element:labels.text.fill|color:0xd59563"],
            ["style", "feature:water|element:geometry|color:0x17263c"],
            ["style", "feature:water|element:labels.text.fill|color:0x515c6d"],
            ["style", "feature:water|element:labels.text.stroke|color:0x17263c"],
        ] : [])
    ])

    return (
        <Card p="0.25rem" bg={theme.colorScheme === "dark" ? "dark.5" : "gray.1"} shadow="">
            <Stack spacing="xs">
                <Box m="0.75rem" mb={0}>
                    <Text color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                        <Group spacing="xs">
                            <IconMapPin size={20} />
                            {L("Location")}
                        </Group>
                    </Text>
                </Box>
                <Image
                    radius={theme.defaultRadius}
                    src={`https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`}
                />
            </Stack>
        </Card>
    )
}

export default DeviceSummaryLocationCard
